<div class="author-node-container">
  <div class="author-node">
    <div class="avatar">{{ (author?.user?.name || documentNode?.content || 'A').charAt(0) }}</div>
    <div class="details">
      <div class="name">{{ author?.user?.name || documentNode?.content || 'Unassigned author' }}</div>
      @if (author?.user?.email) {
        <div class="meta">{{ author.user.email }}</div>
      }
    </div>
  </div>
  @if (editMode && !isAssignedCurrentUser) {
    <div class="author-actions">
      <button mat-mini-fab color="primary" matTooltip="Edit author" aria-label="Edit author" (click)="editAuthor()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-mini-fab color="warn" matTooltip="Remove author" aria-label="Remove author" (click)="removeAuthor()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }
  @if (documentNode.comments?.length > 0) {
    @for (comment of documentNode.comments; track comment) {
      <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
    }
  }
</div>
